<template>
	<div class="full-width page">
		<section id="dynamic-page">
			Loading...
		</section>
	</div>
</template>

<script>
export default {
	name: "DynamicPage",
};
</script>

<style lang="scss" src="./styles.scss" scoped></style>
